import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export default function SelectDropdown({ placeHolder, options, inputValue }) {
  const [inputData, setInputData] = React.useState("");

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    setInputData(selectedValue);
    inputValue(selectedValue);
  };

  return (
    <div>
      <FormControl
        sx={{ m: 1, minWidth: 120 }}
        className={!inputData ? "placeholder_Class" : ""}
      >
        <Select value={inputData} onChange={handleChange} displayEmpty>
          {placeHolder ? (
            <MenuItem value="" disabled>
              {placeHolder}
            </MenuItem>
          ) : (
            <></>
          )}
          {options.map((item) => (
            <MenuItem value={item.name} key={item.id}>
              {item.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
